import { BaseEntityModel } from '/@/modules/core/app/models/abstracts/BaseEntityModel';
import NumeralService from '@/modules/core/app/services/NumeralService';
import { ColumnFormat } from '@/modules/core/app/constants/data.constants';
import { boolToString } from '@/modules/core/app/helpers/StringHelper';

export class FinalTaxesAsset extends BaseEntityModel {
  constructor(model: Partial<FinalTaxesAsset> = {}) {
    super(model);
  }

  get formattedMarketValue(): string {
    return this.formattedCurrencyValue(this.marketValue ?? 0);
  }

  get formattedPurchasePrice(): string {
    return this.formattedCurrencyValue(this.purchasePrice ?? 0);
  }

  get formattedRollOver(): string {
    return this.formattedBooleanValue(this.rollOver ?? false);
  }

  formattedCurrencyValue(value): string {
    return NumeralService.formatValue(
      value,
      ColumnFormat.FORMAT_CURRENCY,
      2,
      false,
      '$',
      true,
      true
    );
  }

  formattedBooleanValue(value): string {
    return boolToString(value);
  }
}
